import styled from '@emotion/styled';
import css from '@styled-system/css';
import { variant } from 'styled-system';

import Flex from '../../layouts/Flex';

const Decoration = styled(Flex)(
  css({
    width: 'auto',
    margin: 0,
    padding: 0,
    backgroundColor: 'white',
    border: '2px solid #aaa',
    borderRadius: '100%',
    position: 'absolute',
    size: 'decorationLine.disk.small',
    left: '50%',
    transform: 'translateX(-50%)',
  }),
  variant({
    prop: 'color',
    variants: {
      default: {
        backgroundColor: 'decorationLine.default',
        borderColor: 'decorationLine.default',
      },
      negative: {
        backgroundColor: 'decorationLine.negative',
        borderColor: 'decorationLine.negative',
      },
      dark: {
        backgroundColor: 'decorationLine.dark',
        borderColor: 'decorationLine.dark',
      },
      grey: {
        backgroundColor: 'decorationLine.grey',
        borderColor: 'decorationLine.grey',
      },
      train: {
        backgroundColor: 'decorationLine.train',
        borderColor: 'decorationLine.train',
      },
      flight: {
        backgroundColor: 'decorationLine.flight',
        borderColor: 'decorationLine.flight',
      },
      primary: {
        backgroundColor: 'decorationLine.primary',
        borderColor: 'decorationLine.primary',
      },
    },
  }),
  variant({
    prop: 'type',
    variants: {
      none: {
        visibility: 'hidden',
      },
      disk: {
        size: 'decorationLine.disk',
        borderWidth: 0,
      },
      circle: {
        size: 'decorationLine.disk',
        backgroundColor: 'white',
        borderWidth: 2,
        borderStyle: 'solid',
      },
      circleDot: {
        backgroundColor: 'white',
        borderWidth: 2,
        borderStyle: 'solid',
      },
    },
  }),
  variant({
    prop: 'reverse',
    variants: {
      true: {
        right: '50%',
        transform: 'translateX(50%)',
      },
    },
  }),
  ({ type }) => {
    if (type === 'circleDot') {
      return variant({
        prop: 'decorationSize',
        variants: {
          small: {
            size: 'decorationLine.circleDot.outsideCircle.small',
          },
          base: {
            size: 'decorationLine.circleDot.outsideCircle.base',
          },
          big: {
            size: 'decorationLine.circleDot.outsideCircle.big',
          },
        },
      });
    } else if (['disk', 'circle'].includes(type)) {
      return variant({
        prop: 'decorationSize',
        variants: {
          small: {
            size: 'decorationLine.disk.small',
          },
          base: {
            size: 'decorationLine.disk.base',
          },
          big: {
            size: 'decorationLine.disk.big',
          },
        },
      });
    }
  }
);

export default Decoration;
